(function () {
  'use strict';

  function init() {
    document.querySelectorAll('[data-mushq-tabs]').forEach(wrap => {
      if (wrap._morliMushqInit) return;
      wrap._morliMushqInit = true;

      const btns = [...wrap.querySelectorAll('[data-mushq-btn]')];
      const panels = [...wrap.querySelectorAll('[data-mushq-panel]')];

      btns.forEach(btn => {
        btn.addEventListener('click', () => {
          const id = btn.dataset.mushqBtn;
          btns.forEach(b => { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
          panels.forEach(p => p.classList.remove('is-active'));
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          const panel = wrap.querySelector(`[data-mushq-panel="${id}"]`);
          if (panel) panel.classList.add('is-active');
        });
      });
    });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
})();
